module.exports = __webpack_public_path__ + "img/knu2_gallery4.9e7992dc.jpg";